/**
 * Flag utilities for on-premises environments that limit us from
 * using launchdarkly.
 */

/**
 * Convert an LD flag key into an env variable name
 *
 * @param flagKey key of launchdarkly flag
 */
const featureFlagToEnvVariable = (flagKey: string) => {
  const screamingSnakeCase = flagKey.toUpperCase().replace(/-/g, '_');
  return `FLAG_${screamingSnakeCase}`;
};

type MakeFlagParserOpts = {
  getEnvVar: (key: string) => string | undefined;
};

type FlagValue =
  | string
  | number
  | boolean
  | undefined
  | Record<string, unknown>;

export const makeFlagParser = ({ getEnvVar }: MakeFlagParserOpts) => {
  return (key: string): FlagValue => {
    const valueFromEnv = getEnvVar(featureFlagToEnvVariable(key));

    if (typeof valueFromEnv !== 'undefined') {
      try {
        // numbers, booleans, objects should all parse properly via JSON
        return JSON.parse(valueFromEnv);
      } catch {
        // only thing that should be failing to parse is
        // a string. we can return those raw
        return valueFromEnv;
      }
    }
    return undefined;
  };
};
